import { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Loading from './components/Loading';
import HeaderContext from './context/HeaderContext';
import Routes from './routes/routes.js';
import PublicRoutes from './routes/public-routes';
import SideBar from './components/SideBar';
import LoginAsHeader from './components/LoginAsHeader';
import FlexBox from './components/FlexBox';
import 'semantic-ui-css/semantic.min.css';
import useLocalStorage from './libs/useLocalStorage';

function App() {
	const [ jwt_token, setJwt ]                               = useLocalStorage(`jwt_token`);
	const [ user, setUser ]                                   = useLocalStorage(`user`);
	const [ original_jwt_token, setOriginalJwt ]              = useLocalStorage(`original_jwt_token`);
	const [ original_user, setOriginalUser ]                  = useLocalStorage(`original_user`);
	const [ localStorageOrgId, setLocalStroageOrgId ]         = useLocalStorage(`current_organization_id`);
	const [ localStorageProjectId, setLocalStorageProjectId ] = useLocalStorage(`current_project_id`);

	const [ checking_auth, setCheckingAuth ]             = useState(true);
	const [ current_organization_id, setOrganizationId ] = useState(localStorageOrgId);
	const [ current_project_id, setProjectId ]           = useState(localStorageProjectId);

	useEffect(() => {
		// Make call to check valid token if one is present
		if(!jwt_token) {
			setCheckingAuth(false);
		}

		setCheckingAuth(false);
	}, [jwt_token]);

	function updateOrganizationId(id) {
		setLocalStroageOrgId(id);
		setOrganizationId(id);

		updateProjectId(null);
	}

	function updateProjectId(id) {
		setLocalStorageProjectId(id);
		setProjectId(id);
	}

	function updateUser(user) {
		setUser(user)
	}

	function updateSwitchUser(active_user, active_jwt, login_as = true) {
		active_user = active_user || original_user;
		active_jwt  = active_jwt || original_jwt_token;

		setOriginalJwt(login_as ? jwt_token : null);
		setOriginalUser(login_as ? user : null);

		setUser(active_user);
		setJwt(active_jwt);

		setLocalStroageOrgId(null);
		setLocalStorageProjectId(null);
	}

	function clearLocalStorage() {
		setJwt(null);
		setUser(null);
		setOriginalJwt(null);
		setOriginalUser(null);
		setOrganizationId(null);
		// setProjectId(null);
		setLocalStroageOrgId(null);
	}

	if(checking_auth) {
		return <Loading />
	}

	const context_values = {
		user,
		current_organization_id,
		current_project_id,
		clearLocalStorage,
		updateSwitchUser,
		updateUser,
		updateOrganizationId,
		updateProjectId,
	};

	// if(jwt_token && (![`active`, `free`].includes(user.payment_status) && !user.super_user && user.organization_id !== 2)) {
	// 	return (
	// 		<Router>
	// 			<div>
	// 				<HeaderContext.Provider value={context_values}>
	// 					<Routes
	// 						needs_payment={true}
	// 					/>
	// 				</HeaderContext.Provider>
	// 			</div>
	// 		</Router>
	// 	);
	// }

	return (
		<Router>
			<div>
				{!jwt_token ? (
					<HeaderContext.Provider value={context_values}>
						<PublicRoutes />
					</HeaderContext.Provider>
				) : (
					<HeaderContext.Provider value={context_values}>
						{original_user &&
							<LoginAsHeader original_user={original_user} user={user} />
						}

						<FlexBox>
							<SideBar />

							<Routes />
						</FlexBox>
					</HeaderContext.Provider>
				)}
			</div>
		</Router>
	);
}

export default App;
